import { createContext } from 'react';

const PublicEventsContext = createContext();

export default PublicEventsContext;
